export namespace Annotations {
  export enum Nags {
    $1 = '$1',
    $2 = '$2',
    $3 = '$3',
    $4 = '$4',
    $5 = '$5',
    $6 = '$6',
    $8 = '$8',
    $9 = '$9',
    $10 = '$10',
    $11 = '$11',
    $12 = '$12',
    $13 = '$13',
    $14 = '$14',
    $15 = '$15',
    $16 = '$16',
    $17 = '$17',
    $18 = '$18',
    $19 = '$19',
    $22 = '$22',
    $23 = '$23',
    $32 = '$32',
    $33 = '$33',
    $36 = '$36',
    $37 = '$37',
    $40 = '$40',
    $41 = '$41',
    $44 = '$44',
    $45 = '$45',
    $132 = '$132',
    $133 = '$133',
    $138 = '$138',
    $146 = '$146',
    $222 = '$222',
    $256 = '$256',
  }

  export enum Values {
    $1 = '!',
    $2 = '?',
    $3 = '!!',
    $4 = '??',
    $5 = '!?',
    $6 = '?!',
    $8 = '□',
    $9 = '☒',
    $10 = '=',
    $11 = '=',
    $12 = '=',
    $13 = '∞',
    $14 = '⩲',
    $15 = '⩱',
    $16 = '±',
    $17 = '∓',
    $18 = '+-',
    $19 = '-+',
    $22 = '⨀',
    $23 = '⨀',
    $32 = '⟳',
    $33 = '⟳',
    $36 = '→',
    $37 = '→',
    $40 = '↑',
    $41 = '↑',
    $44 = '∞/=',
    $45 = '=/∞',
    $132 = '⇆',
    $133 = '⇆',
    $138 = '⊕',
    $146 = 'N',
    $222 = '⇈',
    $256 = '=/∞',
  }

  export enum Effects {
    GreatFind = '!',
    Mistake = '?',
    Brilliant = '!!',
    Blunder = '??',
    Interesting = '!?',
    Inaccuracy = '?!',
  }

  export enum Additional {
    Drawish = '=',
    Unclear = '∞',
    WhiteHasModerateAdvantage = '±',
    BlackHasModerateAdvantage = '∓',
    WhiteHasDecisiveAdvantage = '+-',
    BlackHasDecisiveAdvantage = '-+',
    PositionInZugzwang = '⨀',
    WithCompensation = '↑',
    Novelty = 'N',
    WithAttack = '=/∞',
  }
}
